import { useEffect, useMemo, useRef } from 'react';
import { FormControl } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setSeparator } from '../common/commonSlice';
import { show as showToast } from '../toast/toastSlice';

import { copy } from '../../services/util';
import { hide } from './skillPracSlice';

function InnerSkillPracModal() {
  const dispatch = useAppDispatch();
  const skills = useAppSelector(state => state.skillTrainer.skills);
  const professions = useAppSelector(state => state.skillTrainer.professions);
  const commands = useAppSelector(state => state.skillTrainer.commands);
  const residualOrderIds = useAppSelector(state => state.skillTrainer.residualOrderIds);
  const residualOrderType = useAppSelector(state => state.skillTrainer.residualOrderType);
  const profession = useAppSelector(state => state.skillTrainer.professions.find(x => x.id === state.skillPrac.professionId)!);
  const separator = useAppSelector(state => state.common.separator);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const title = profession?.name;
  const text = commands[profession.id];

  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  
  const textMemo = useMemo(() => {
    return separator?.trim() ? text.split('\n').join(separator) : text;
  }, [text, separator]);
  
  let warning = '';
  switch (residualOrderType) {
    case 'profession':
      warning = residualOrderIds.map(id => professions.find(x => x.id === id)?.name).join(', ');
      break;
    case 'skill':
      warning = residualOrderIds.map(id => skills.find(x => x.id === id)?.name).join(', ');
      break;
  }

  const handleCopyClick = () => {
    copy(textMemo);
    dispatch(hide());
    dispatch(showToast('Copied to clipboard.'));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.code === 'Enter') {
      e.preventDefault();
      handleCopyClick();
    }
  };

  const handleSeparatorChange = (value: string) => {
    dispatch(setSeparator(value));
  }

  return (
    <Modal show={true} onHide={() => dispatch(hide())}>
      <Modal.Header closeButton>
        <Modal.Title>{title} Practices</Modal.Title>
      </Modal.Header>
      <Modal.Body>
          {warning ?
          <div className="text-warning mb-3">
            <div className="mb-0">Please practice residuals in the following order:</div>
            <div>{warning}</div>
          </div> : null}
        <FormControl as="textarea" value={textMemo || 'None'} rows={6} readOnly ref={inputRef} onKeyDown={handleKeyDown} />
      </Modal.Body>
      <Modal.Footer>
        <div className="me-auto">
          <span className="me-2">Separator:</span>
          <FormControl className="separator" as="input" value={separator} onChange={e => handleSeparatorChange(e.target.value)} onKeyDown={handleKeyDown} />
        </div>
        <Button variant="secondary" onClick={() => dispatch(hide())}>
          Close
        </Button>
        <Button variant="primary" onClick={() => handleCopyClick()}>
          Copy
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function SkillPracModal() {
  const visible = useAppSelector(state => state.skillPrac.visible);  
  return visible ? <InnerSkillPracModal/> : null;
}

export default SkillPracModal;